import { noTokenHttpClient } from "../utils/httpClient";
import { post } from "../utils/httpClients-methods";
import { API_URL } from "../utils/AppApiUrl";
import { padPO } from "../utils/jsUtils";

const verifyVendorService = async (baseURL, requestBody) => {
  try {
    const verifyVendorRequestObj = {
      vendorCode: padPO(requestBody?.vendorCode),
      gstin: requestBody?.gstin,
    };
    const verifyVendorResponse = await post(
      noTokenHttpClient,
      `${baseURL}${API_URL.verifyVendor}`,
      JSON.stringify(verifyVendorRequestObj)
    );
    if (verifyVendorResponse?.status === 200 && verifyVendorResponse.data) {
      return verifyVendorResponse.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export const termsAndConditionService = async (baseURL) => {
  try {
    const termsAndConditionResponse = await post(
      noTokenHttpClient,
      `${baseURL}${API_URL.termsAndCondition}`
    );
    if (
      termsAndConditionResponse?.status === 200 &&
      termsAndConditionResponse.data
    ) {
      return termsAndConditionResponse.data;
    } else {
      return {};
    }
  } catch (err) {
    throw err;
  }
};

export default verifyVendorService;
